import { markBars, markViewBox, wordmark } from '@/components/brand/brandPaths'

const MarkBars = () =>
  markBars.map((bar) => <path key={bar.variable} d={bar.d} style={{ fill: `var(${bar.variable}, currentColor)` }} />)

/** SVG symbols referenced by `<use>` across the site. Rendered once, by SiteShell. */
export const BrandSprite = () => (
  <svg
    width="0"
    height="0"
    aria-hidden="true"
    focusable="false"
    style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
  >
    <defs>
      <symbol id="ua-mark" viewBox={markViewBox}>
        <MarkBars />
      </symbol>
      <symbol id="ua-lockup" viewBox="4 0 202 60.72">
        <MarkBars />
        <path d={wordmark.d} transform={wordmark.transform} style={{ fill: 'var(--wm, currentColor)' }} />
      </symbol>
      <symbol id="i-arrow" viewBox="0 0 16 16">
        <path
          d="M3 8h9.5M8.8 4.3 12.5 8l-3.7 3.7"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-check" viewBox="0 0 16 16">
        <path
          d="M4 8.4 6.8 11 12 5.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-person" viewBox="0 0 16 16">
        <circle cx="8" cy="5.4" r="2.5" fill="currentColor" />
        <path d="M3.4 13.2c.6-2.6 2.4-3.9 4.6-3.9s4 1.3 4.6 3.9z" fill="currentColor" />
      </symbol>
    </defs>
  </svg>
)
